import r from "./bearer-token-interceptor.js";
import e from "./accept-language-interceptor.js";
import o from "./api-key-interceptor.js";
import t from "./url-interceptor.js";
import p from "./x-traceid-interceptor.js";
const I = {
  bearerTokenInterceptor: r,
  acceptLanguageInterceptor: e,
  apiKeyInterceptor: o,
  urlInterceptor: t,
  xTraceidInterceptor: p
};
export {
  I as axiosInterceptors
};
//# sourceMappingURL=index.js.map
